import {VehicleTypeEnum} from '@dms/api/shared';

import type {OrderActions} from '../metadaWorkshopServiceOrderActions/types';

export type PostServiceCaseApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      additional_action?: 'MERCEDES_XENTRY_LINK'[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceCaseApiArg = {
  body: {
    id?: string | null;
    vehicleId: string | null;
    customerId: string | null;
    vin?: string | null;
    make: string | null;
    modelFamily?: string | null;
    type: VehicleTypeEnum | null;
    registrationPlate?: string | null;
  } | null;
};
export type GetMetadaServiceCaseApiResponse =
  | /** status 200 Standard response */ ({
      id?: string;
      number?: string | null;
      state?:
        | 'DEMAND'
        | 'DRAFT'
        | 'HANDED_OVER'
        | 'PLANNED'
        | 'CANCELLED'
        | 'CHECKED_IN'
        | 'CREATED'
        | null;
      ordersState?:
        | 'CANCELLED'
        | 'CLOSED'
        | 'IN_PROGRESS'
        | 'LOCKED'
        | 'OFFER'
        | 'OPEN'
        | 'PAUSED'
        | 'PLANNED'
        | 'REQUEST'
        | 'WORK_DONE'
        | 'DRAFT'
        | null;
      vehicleId?: string | null;
      customerId?: string | null;
      businessCaseId?: string | null;
      description?: string | null;
      totalPrice?: number | null;
      totalPriceWithVat?: number | null;
      currency?: string | null;
      createdAt?: string | null;
      createdBy?: string | null;
      closedAt?: string | null;
      repeatedRepair?: boolean | null;
      markers?: string[] | null;
      sparePartWarehouseState?: string | null;
      timeTrackingState?: string | null;
      authorizationProfileId?: string | null;
      serviceCaseTypeId: string;
      branchId: string;
      bookingUrl?: string | null;
      repairUrl?: string | null;
      contactInformation?: {
        customerId?: string | null;
        contactId?: string | null;
        name?: string | null;
        phoneNumber?: {
          countryCode: string;
          prefix?: string | null;
          number?: string | null;
        } | null;
        email?: string | null;
        identityCard?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetMetadaServiceCaseApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type DeleteServiceCaseApiResponse = unknown;
export type DeleteServiceCaseApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type DeleteServiceCaseJobApiResponse = unknown;
export type DeleteServiceCaseJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceCaseJobId: string;
};
export type GetCaseItemsTotalAmountApiResponse =
  | /** status 200 Standard response */ ({
      message?: string | null;
      error?: {
        message?: string | null;
        data?: {
          [key: string]: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
        } | null;
      } | null;
      errors?: ({
        message?: string | null;
        code?: string | null;
      } | null)[];
      validationErrors?: ({
        message?: string | null;
        field?: string | null;
      } | null)[];
      discount?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      totalPrice?: {
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        vat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetCaseItemsTotalAmountApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type GetPostponeJobsApiResponse =
  | /** status 200 Standard response */ ({
      postponeJob?: ({
        postponeJobId: string;
        name?: string | null;
        postponedUntil?: string | null;
        postponeReason?: string | null;
        postponedAt: string;
        postponedBy: string;
      } | null)[];
      count?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetPostponeJobsApiArg = {
  serviceCaseId: string;
};
export type GetServiceCaseJobApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'DRAFT'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'LOCKED'
        | 'CLOSED'
        | null;
      name?: string | null;
      orderVariantId?: string | null;
      description?: string | null;
      solution?: string | null;
      workTeam?: string | null;
      workTimeEstimated?: number | null;
      totalPriceEstimated?: {
        amount?: number | null;
        currency?: string | null;
      } | null;
      repeatedRepair?: boolean | null;
      partsReturn?: boolean | null;
      priority?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceJobId: string;
};
export type GetServiceCaseOrdersApiResponse =
  /** status 200 Standard response */
  | {
      serviceOrderId: string;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'INVOICED'
        | 'CLOSED'
        | 'LOCKED'
        | 'CORRECTING_FULLY'
        | 'CORRECTING_PARTIALLY'
        | null;
      number: string;
      markers?: string[] | null;
      timeTrackingState?: string | null;
      sparePartWarehouseState?: string | null;
      claimDecision?: string | null;
      totalSalesPrice?: {
        withoutVat?: {
          amount: number;
          currency: string;
        } | null;
        vat?: {
          amount: number;
          currency: string;
        } | null;
        withVat?: {
          amount: number;
          currency: string;
        } | null;
      } | null;
      materialSalesPrice?: {
        withoutVat?: {
          amount: number;
          currency: string;
        } | null;
        vat?: {
          amount: number;
          currency: string;
        } | null;
        withVat?: {
          amount: number;
          currency: string;
        } | null;
      } | null;
      labourSalesPrice?: {
        withoutVat?: {
          amount: number;
          currency: string;
        } | null;
        vat?: {
          amount: number;
          currency: string;
        } | null;
        withVat?: {
          amount: number;
          currency: string;
        } | null;
      } | null;
      smallUnitMaterialSalesPrice?: {
        withoutVat?: {
          amount: number;
          currency: string;
        } | null;
        vat?: {
          amount: number;
          currency: string;
        } | null;
        withVat?: {
          amount: number;
          currency: string;
        } | null;
      } | null;
      totalPriceEstimated?: {
        amount: number;
        currency: string;
      } | null;
      estimatedCompletionDate?: string | null;
      orderClosedDate?: string | null;
      orderCancelledDate?: string | null;
      serviceOrderVariant?: {
        serviceOrderVariantId: string;
        name: string;
      } | null;
      billingRecipient?: string | null;
      billingInformation?: {
        customerInformation?: {
          customerId: string;
          displayName: string;
        } | null;
        contractInformation?: {
          contractId: string;
          legalForm: string;
          name: string;
        } | null;
      } | null;
      contactInformation?: {
        id: string;
        name: string;
        email: string;
        phoneNumber?: {
          countryCode: string;
          prefix: string;
          number: string;
        } | null;
      } | null;
      customerContract?: {
        customerContractId: string;
        name: string;
        validityUntil: string;
        customerType: string;
      } | null;
      isCustomerSyncEnabled?: boolean | null;
      hasMarginUnderMinimum: boolean;
      orderActions?: OrderActions;
      vehicleClassId?: string | null;
    }[]
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseOrdersApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type PostServiceCaseJobFromPostponeJobApiResponse =
  | /** status 200 Standard response */ ({
      error?: {
        message?: string | null;
        data?: {
          [key: string]: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
        } | null;
      } | null;
      errors?: ({
        message?: string | null;
        code?: string | null;
      } | null)[];
      validationErrors?: ({
        message?: string | null;
        field?: string | null;
      } | null)[];
      id?: string | null;
      state?: string | null;
      name?: string | null;
      orderVariantId?: string | null;
      description?: string | null;
      solution?: string | null;
      workTeam?: string | null;
      workTimeEstimated?: number | null;
      totalPriceEstimated?: number | null;
      repeatedRepair?: boolean | null;
      partsReturn?: boolean | null;
      priority?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceCaseJobFromPostponeJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  serviceOrderVariantId: string;
  /** UUID */
  postponeJobId: string;
};
export type PatchServiceCaseApiResponse =
  | /** status 200 Standard response */ ({
      serviceCaseId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceCaseApiArg = {
  /** UUID */
  serviceCaseId: string;
  body: {
    id?: string | null;
    vehicleId: string;
    customerId: string;
    vin?: string | null;
    make: string | null;
    modelFamily: string | null;
    type: VehicleTypeEnum | null;
    registrationPlate?: string | null;
    contactInformation?: {
      customerId: string;
      contactId?: string | null;
    } | null;
  } | null;
};
export type GetServiceCaseByServiceOrderIdApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      number?: string | null;
      state?: string | null;
      ordersState?: string | null;
      vehicleId?: string | null;
      businessCaseId?: string | null;
      customerId?: string | null;
      description?: string | null;
      markers?: (string | null)[];
      createdAt?: string | null;
      createdBy?: string | null;
      updatedAt?: string | null;
      updatedBy?: string | null;
      closedAt?: string | null;
      closedBy?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseByServiceOrderIdApiArg = {
  /** UUID */
  serviceOrderId: string;
};
export type PostServiceCaseCreateOrdersApiResponse = unknown;
export type PostServiceCaseCreateOrdersApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type GetServiceCaseJobsApiResponse =
  | ({
      id?: string | null;
      allowedActions?: ('REJECT_CAMPAIGN' | 'ACTIVATE_CAMPAIGN')[];
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'DRAFT'
        | 'REQUEST'
        | 'OFFER'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'LOCKED'
        | 'CLOSED'
        | 'SVCPOSTPONEJOB_POSTPONE'
        | 'SVCPOSTPONEJOB_DONE'
        | 'SVCPOSTPONEJOB_CANCELLED'
        | null;
      name?: string | null;
      orderVariantId?: string | null;
      description?: string | null;
      solution?: string | null;
      workTeam?: string | null;
      workTimeEstimated?: number | null;
      totalPriceEstimated?: number | null;
      repeatedRepair?: boolean | null;
      partsReturn?: boolean | null;
      priority?: number | null;
      partsRequest?: boolean | null;
      partsReady?: boolean | null;
      competencyId?: string | null;
      isUncategorized?: boolean | null;
      isServicePackage?: boolean | null;
      servicePackageDetails?: {
        id?: string | null;
        name?: string | null;
        number?: string | null;
        isLock?: boolean | null;
      } | null;
      isFixedPrice?: boolean | null;
      fixedPrice?: {
        isUniformVatType?: boolean | null;
        withoutVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
        vat?: {
          type?: string | null;
          amount?: number | null;
          currency?: string | null;
        } | null;
        withVat?: {
          amount?: number | null;
          currency?: string | null;
        } | null;
      } | null;
      hasItems?: boolean | null;
      timeTrackingState?: string | null;
      assignMechanics?: ({
        id?: string | null;
        name?: string | null;
        isDefault?: boolean | null;
        costCenterId?: string | null;
      } | null)[];
      isServiceCampaign?: boolean | null;
      serviceCampaignDetails?: {
        id?: string | null;
        platformCode?: string | null;
        serviceCode?: string | null;
        description?: string | null;
        defectCode?: string | null;
        startDate?: string | null;
        dueDate?: string | null;
      } | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseJobsApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type GetServiceCaseOrderVariantsApiResponse =
  /** status 200 Standard response */
  | ({
      serviceOrderVariantId?: string | null;
      name?: string | null;
      serviceOrderType?: {
        serviceOrderTypeId: string;
        type: string;
      } | null;
      isDefault?: boolean | null;
      isActive?: boolean | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseOrderVariantsApiArg = {
  /** UUID */
  serviceCaseId: string;
};
export type PatchServiceCaseJobApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'DRAFT'
        | 'REQUEST'
        | 'OFFER'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'LOCKED'
        | 'CLOSED'
        | 'SVCPOSTPONEJOB_POSTPONE'
        | 'SVCPOSTPONEJOB_DONE'
        | 'SVCPOSTPONEJOB_CANCELLED'
        | null;
      name?: string | null;
      orderVariantId?: string | null;
      description?: string | null;
      solution?: string | null;
      workTeam?: string | null;
      workTimeEstimated?: number | null;
      totalPriceEstimated?: number | null;
      repeatedRepair?: boolean | null;
      partsReturn?: boolean | null;
      priority?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchServiceCaseJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceCaseJobId: string;
  body: {
    state?:
      | (
          | 'ARCHIVED'
          | 'CANCELLED'
          | 'DRAFT'
          | 'REQUEST'
          | 'OFFER'
          | 'OPEN'
          | 'INPROGRESS'
          | 'PAUSED'
          | 'WORKDONE'
          | 'LOCKED'
          | 'CLOSED'
          | 'SVCPOSTPONEJOB_POSTPONE'
          | 'SVCPOSTPONEJOB_DONE'
          | 'SVCPOSTPONEJOB_CANCELLED'
          | 'POSTPONED'
        )
      | null;
    name?: string | null;
    orderVariantId?: string | null;
    description?: string | null;
    solution?: string | null;
    workTeam?: string | null;
    workTimeEstimated?: number | null;
    totalPriceEstimated?: number | null;
    repeatedRepair?: boolean | null;
    partsReturn?: boolean | null;
    priority?: number | null;
  } | null;
};
export type PostServiceCaseJobApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      state?:
        | 'ARCHIVED'
        | 'CANCELLED'
        | 'DRAFT'
        | 'REQUEST'
        | 'OFFER'
        | 'POSTPONED'
        | 'OPEN'
        | 'INPROGRESS'
        | 'PAUSED'
        | 'WORKDONE'
        | 'LOCKED'
        | 'CLOSED'
        | null;
      name?: string | null;
      orderVariantId?: string | null;
      description?: string | null;
      solution?: string | null;
      workTeam?: string | null;
      workTimeEstimated?: number | null;
      totalPriceEstimated?: number | null;
      repeatedRepair?: boolean | null;
      partsReturn?: boolean | null;
      priority?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostServiceCaseJobApiArg = {
  /** UUID */
  serviceCaseId: string;
  body: {
    id?: string | null;
    state?:
      | (
          | 'ARCHIVED'
          | 'CANCELLED'
          | 'DRAFT'
          | 'REQUEST'
          | 'OFFER'
          | 'POSTPONED'
          | 'OPEN'
          | 'INPROGRESS'
          | 'PAUSED'
          | 'WORKDONE'
          | 'LOCKED'
          | 'CLOSED'
        )
      | null;
    name?: string | null;
    orderVariantId?: string | null;
    description?: string | null;
    solution?: string | null;
    workTeam?: string | null;
    workTimeEstimated?: number | null;
    totalPriceEstimated?: number | null;
    repeatedRepair?: boolean | null;
    partsReturn?: boolean | null;
    priority?: number | null;
  } | null;
};
export type PostServiceCaseCopyServiceRequestsApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceCaseCopyServiceRequestsApiArg = {
  serviceCaseId: string;
  body: {
    serviceJobIds: string[];
  };
};
export type GetServiceCaseJobItemsCountApiResponse =
  | /** status 200 Standard response */ ({
      itemCount: number;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseJobItemsCountApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceJobId: string;
};
export type GetServiceCaseAdditionalInformationApiResponse =
  /** status 200 Standard response */
  | ({
      message: string;
      code: string;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetServiceCaseAdditionalInformationApiArg = {
  serviceCaseId: string;
};
export type GetServiceCaseServiceRepairApiResponse =
  | /** status 200 Standard response */ ({
      /** UUID */
      serviceRepairId: string;
      repairUrl: string;
      isDirectReception: boolean;
      isCustomerWaiting: boolean;
      isSelfServiceAllowed: boolean;
      doorToDoors?: ({
        startAt: string;
        endAt: string;
        employee?: {
          id?: string | null;
          name?: string | null;
        } | null;
        address?: {
          city: string | null;
          street: string | null;
          zip: string | null;
          state?: string | null;
          prefix?: string | null;
          descriptiveNumber?: string | null;
          orientationNumber?: string | null;
          addressComplement?: string | null;
          district?: string | null;
          country: string;
          postal?: string | null;
        } | null;
        contactPerson?: {
          name: string;
          email?: string | null;
          phoneNumber?: {
            countryCode: string;
            prefix: string | null;
            number: string;
          } | null;
        } | null;
      } | null)[];
      checkin?: {
        plannedAt: string;
        employee?: {
          id?: string | null;
          name?: string | null;
        } | null;
      } | null;
      activities: ({
        name: string;
        competence?: {
          id?: string | null;
          name?: string | null;
        } | null;
        employee?: {
          id?: string | null;
          name?: string | null;
        } | null;
        startAt?: string | null;
        endAt?: string | null;
      } | null)[];
      carWashes?: ({
        startAt: string;
        endAt: string;
        programName: string;
        /** For example, 0.25 is 15 minutes */
        estimatedTime: number;
      } | null)[];
      replacementVehicles?: ({
        vehicle?: {
          name: string;
          vin?: string | null;
          registrationNumber: string;
        } | null;
        startAt: string;
        endAt: string;
      } | null)[];
      handover?: {
        plannedAt: string;
        employee?: {
          id?: string | null;
          name?: string | null;
        } | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetServiceCaseServiceRepairApiArg = {
  serviceCaseId: string;
};

export interface GetPendingServiceItemsApiArg {
  serviceCaseId: string;
}

export interface ServiceItemBasket {
  serviceOrderId: string;
  serviceJobId: string;
}

export type GetPendingServiceItemsApiResponse =
  | {
      workBasket?: ServiceItemBasket[];
      materialBasket?: ServiceItemBasket[];
    }
  // "No pending items" arrives as 204/no content from the granular endpoint and as a
  // null slice from the detail-bootstrap seed.
  | null
  | /** status 204 Standard response */ undefined;

export interface GetPendingServiceOrderReturnApiArg {
  serviceCaseId: string;
}

export type GetPendingServiceOrderReturnApiResponse =
  | /** status 200 Standard response */ ({
      serviceOrderReturnId: string;
    } | null)
  | /** status 204 Standard response */ undefined;

export type GetServiceCaseOrderCountApiResponse =
  | /** status 200 Standard response */ ({
      count: number;
    } | null)
  | /** status 204 Standard response */ undefined;

export type GetServiceCaseOrderCountApiArg = {
  /** UUID */
  serviceCaseId: string;
};

export type PostServiceCaseXentryCampaignRejectApiResponse =
  /** status 204 Standard response */ undefined;

export type PostServiceCaseXentryCampaignRejectApiArg = {
  serviceCaseId: string;
  serviceJobId: string;
  body: {
    rejectionReason: string;
  };
};

export type PostServiceCaseXentryCampaignActivateApiResponse =
  /** status 204 Standard response */ undefined;

export type PostServiceCaseXentryCampaignActivateApiArg = {
  serviceCaseId: string;
  serviceJobId: string;
};

export type GetServiceCaseXentryCampaignStatusApiResponse =
  /** status 200 Standard response */
  | (
      | {
          serviceOrderId: string;
          serviceJobId: string;
          status?: string | null;
          rejectionReason?: string | null;
        }[]
      | null
    )
  | /** status 204 Standard response */ undefined;

export type GetServiceCaseXentryCampaignStatusApiArg = {
  serviceCaseId: string;
};
